import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1415c4f3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "mb-5 is-flex" }
const _hoisted_3 = { class: "is-flex mb-5" }
const _hoisted_4 = { class: "switch-centered" }
const _hoisted_5 = { class: "switch" }
const _hoisted_6 = ["checked"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "slider round" }, null, -1))
const _hoisted_8 = { class: "mr-1 switch-centered" }
const _hoisted_9 = {
  key: 0,
  class: "is-flax ml-5"
}
const _hoisted_10 = { class: "select center" }
const _hoisted_11 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("label", _hoisted_5, [
            _createElementVNode("input", {
              type: "checkbox",
              checked: _ctx.useCustomLanguage,
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.switchCustomLanguage && _ctx.switchCustomLanguage(...args))),
              ref: "langCheckbox"
            }, null, 8, _hoisted_6),
            _hoisted_7
          ])
        ]),
        _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$gettext("Use custom language")), 1)
      ]),
      (_ctx.useCustomLanguage)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("span", _hoisted_10, [
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.userLanguage) = $event))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$language.available, (name, key) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: key,
                    value: key
                  }, _toDisplayString(name), 9, _hoisted_11))
                }), 128))
              ], 512), [
                [_vModelSelect, _ctx.userLanguage]
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}